import { render, staticRenderFns } from "./AttachmentSidepanel.vue?vue&type=template&id=797b96f4&"
import script from "./AttachmentSidepanel.vue?vue&type=script&lang=js&"
export * from "./AttachmentSidepanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports